// extracted by mini-css-extract-plugin
export default {"container":"Okajk6tc_Cm9k4tzOiwY"};